function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

/**
 * Prevent page scroll when a modal is visible on mobile devices
 */
function preventDefault(e) {
  e.preventDefault();
}

let scrollY; // we'll store the scroll position here

/**
 *
 * @param {*} modal Object. Preferably an element with an ID
 * @returns
 */
function showModal(modal) {
  if (!modal) return;

  // don't apply the prevent-scroll for filters on larger screens
  if (modal.id === "CollectionFiltersForm" && window.innerWidth >= 768) return;

  // remember scroll position
  scrollY = window.scrollY;

  // prevent the body from jumping when the position fixed is added and wait to make sure it's been added
  document.body.style.top = `${
    scrollY < window.innerHeight ? 0 - scrollY : 0
  }px`;
  setTimeout(() => {
    document.documentElement.classList.add("prevent-scroll");
  }, 100);

  modal.addEventListener("pointermove", preventDefault);
}

/**
 *
 * @param {*} modal Object. Should be the same as passed above
 * @returns
 */
function hideModal(modal) {
  if (!modal) return;

  modal.removeEventListener("pointermove", preventDefault);
  document.documentElement.classList.remove("prevent-scroll");
  document.body.style.top = 0;
  // restore scroll position
  window.scrollTo(0, scrollY);
}

const debug = () => {
  return (
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname.indexOf("myshopify.com") !== -1
  );
};

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event?.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document
    .querySelectorAll("product-model")
    .forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}

if (!customElements.get("quantity-input")) {
  customElements.define("quantity-input", QuantityInput);
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function getNodeIndex(node) {
  return Array.from(node.parentNode.children).indexOf(node);
}

// back to top button
document.querySelectorAll("[data-back-to-top]").forEach(($button) => {
  $button.addEventListener("click", (e) => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
  });
});

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt2 = document.createElement("option");
        opt2.value = provinces[i][0];
        opt2.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt2);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

/**
 * unescapeHTML
 * @description Un-escapes an escaped HTML string.
 * @param {String} str an escaped html string
 * @returns {String} an un-escaped html string
 */
function unescapeHTML(str) {
  return str.replace(
    /&amp;|&lt;|&gt;|&#39;|&quot;/g,
    (tag) =>
      ({
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&#39;": "'",
        "&quot;": '"',
      }[tag] || tag)
  );
}

/**
 * Parse Algolia named tags color data
 * @description Parses grouped products color data from Algolia indexed named tags.
 * @param {Object} algoliaItem Algolia variant item
 * @param {String} colorsMapString color mappings set in theme settings
 * @returns {Array}
 */
function parseColorsFromAlgoliaNamedTags(algoliaItem, colorsMapString) {
  let currentColor = algoliaItem?.named_tags["product-colour"];
  let groupColors = algoliaItem?.named_tags["colour-group-product"];

  if (!currentColor) return;

  if (Array.isArray(currentColor)) {
    currentColor = currentColor[0];
  }

  const colorsMap = colorsMapString?.split(",")?.reduce((colors, colorStr) => {
    const parts = colorStr.split("|");

    return parts[1]
      ? {
          ...colors,
          [parts[0]]: parts[1],
        }
      : colors;
  }, {});

  // handleize current color string
  const currentColorHandleized = currentColor
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-$/, "")
    .replace(/^-/, "");

  let allColors = [
    {
      handle: algoliaItem?.handle,
      colorLabel: currentColor,
      colorHex: colorsMap[currentColorHandleized],
    },
  ];

  if (!groupColors) return allColors;

  if (typeof groupColors === "string") {
    groupColors = [groupColors];
  }

  groupColors.forEach((colorStr) => {
    const parts = colorStr.replace(/\s+/g, "").split("|");

    allColors.push({
      handle: parts[0],
      colorLabel: parts[1],
      colorHex: colorsMap[parts[1]],
    });
  });

  return allColors;
}

// remove the cookie popup when developing because it doesn't work and leaves an overlay blocking the page
if (debug()) {
  setTimeout(() => {
    document.getElementById("onetrust-consent-sdk")?.remove();
  }, 3000);
}

/**
 * Fetch additional product data
 * @description Fetches additional product data from an alternate product view (or from session storage if already fetched).
 * @param {String} productHandle
 * @returns {Object}
 */
async function fetchAdditionalProductData(productHandle) {
  const storageKey = "additional-product-data";
  const stored = sessionStorage.getItem(storageKey);
  const storedData = stored ? JSON.parse(stored) : null;

  if (storedData && storedData[productHandle]) {
    return storedData[productHandle];
  }

  const url = `/products/${productHandle}?view=product-data`;

  try {
    const response = await fetch(url);

    if (response.status !== 200) throw new Error(response.status);

    const result = await response.text();

    const resultsMarkup = new DOMParser().parseFromString(result, 'text/html').querySelector('[data-product-data]').innerHTML;
    const productData = JSON.parse(resultsMarkup);

    sessionStorage.setItem(
      storageKey,
      JSON.stringify({
        ...storedData,
        [productHandle]: productData,
      })
    );

    return productData;
  } catch (error) {
    console.error(
      "Error fetching alternate product template ?view=product-data:",
      error
    );
    return;
  }
}
